import crypto from "crypto";
class NonceHandler {
    secretKey = "your_secret_key";
    origin = "WEB";
    constructor() {}
    generateNonce() {
        return crypto.randomBytes(16).toString("hex");
    }

    generateOriginToken() {
        return Buffer.from(this.origin).toString("base64");
    }

    generateSignature(nonce, originToken, requestData) {
        const data = `${originToken}:${nonce}:${JSON.stringify(requestData)}`;
        return crypto
            .createHmac("sha256", this.secretKey)
            .update(data)
            .digest("hex");
    }

    getGeneratedEncryptedCredentials(requestData) {
        const nonce = this.generateNonce();
        const originToken = this.generateOriginToken();
        const signature = this.generateSignature(
            nonce,
            originToken,
            requestData
        );

        return {
            nonce,
            originToken,
            signature,
        };
    }
}

export default new NonceHandler();
